import React from 'react';

function Footer() {
  return (
    <footer className="wrapper">
      <p>&copy; 2020 <a href="http://maximilianlau.com" target="_blank" rel="noopener noreferrer">Maximilian Lau.</a></p>
      <p>Powered by React, The Movies DB, and OMDB</p>
    </footer>
  )
}

export default Footer;